import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '@/common/components';
import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { CloudflareAccountsFormFields, CloudflareAccountsFormInputs } from '@/modules/DomainsApi/Cloudflare';

interface Props extends AppFormProps<typeof CloudflareAccountsFormInputs, CloudflareAccountsFormFields> {}

export const CloudflareAccountsFormView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item name={ CloudflareAccountsFormInputs.Provider } hidden/>

      <Form.Item
        label="E-mail"
        name={ CloudflareAccountsFormInputs.Email }
        hasFeedback
        help={ formErrors?.email }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.email) }
        rules={ validationSchema.email }
      >
        <Input allowClear disabled={ formType === 'edit' || isFormLoading }/>
      </Form.Item>

      <Form.Item
        label="Пароль"
        name={ CloudflareAccountsFormInputs.Password }
        hasFeedback
        help={ formErrors?.password }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.password) }
        rules={ validationSchema.password }
      >
        <Input.Password allowClear/>
      </Form.Item>

      <Form.Item
        label="API ключ"
        name={ CloudflareAccountsFormInputs.ApiKey }
        hasFeedback
        help={ formErrors?.apiKey }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.apiKey) }
        rules={ validationSchema.apiKey }
      >
        <Input.Password allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
